<template>
    <div class="attachment-view">
        <heading :title="title" class="heading">
            <b-button @click="download(true)"
                      size="sm" variant="secondary" class="btn-icon ml-2">
                Preview attachment
                <b-icon-eye class="ml-2"/>
            </b-button>
            <b-button @click="download(false)"
                      size="sm" variant="secondary" class="float-right btn-icon ml-2">
                Download again
                <b-icon-download class="ml-2"/>
            </b-button>
        </heading>

        <h3>
            The attachment should download automatically.
        </h3>

        <b-alert show v-if="!downloadOk" variant="info">
            The download could not be completed because the attachment has not yet been scanned for viruses. Please try again later.
        </b-alert>

    </div>
</template>

<script>
import Vue from 'vue'
import Help from '@/models/Help'
import Authorization from '@/providers/Authorization'

export default Vue.extend({
    name: 'AttachmentView',
    props: {
        attachmentId: Number,
    },
    data () {
        return {
            title: '',
            att: null,
            downloadOk: true,
        }
    },
    methods: {
        download(preview) {
            this.$api.downloadAttachment(this.att, preview)
                .catch((error) => {
                    this.downloadOk = false
                    this.$toasted.error("Download failed")
                })
        },
    },
    created() {
        this.$api.getItem(this, 'attachment', this.attachmentId)
        .then(data => {
            this.title = "Downloading attachment: " + data['name']
            this.att = data
            this.download(false)
        })
    },
})
</script>
